<template>
  <BaseModal :isVisible="isVisible">
    <TitreUn :content="t('createARepair')" />

    <InputField :placeholder="t('repairLabel')" v-model="newLibelle"/>
    <div class="flex flex-row w-full gap-2">
      <InputField class="!w-1/2" :placeholder="t('price')" v-model="newPrix" type="number" :min="0"/>
      <DropDownField class="!w-1/2" :placeholder="t('purchaseType')" :values="typeAchatAvailable" v-model="newTypeAchat"/>
    </div>

    <div class="flex flex-row-reverse justify-start gap-4">
      <BlueButton :text="t('validate')" @click="createRepair" />
      <BlackClickableText :text="t('cancelAction')" @click="closeModal(undefined)" />
    </div>
  </BaseModal>
</template>

<script setup>

import {computed, defineProps, ref} from "vue";
import {t} from "@/utils/Traduction";
import {NotificationStores} from "@/stores/NotificationStores";
import TitreUn from "@/components/atoms/TitreUn.vue";
import InputField from "@/components/molecules/InputField.vue";
import BlueButton from "@/components/molecules/BlueButton.vue";
import BlackClickableText from "@/components/molecules/BlackClickableText.vue";
import BaseModal from "@/components/molecules/BaseModal.vue";
import {TypeAchatStore} from "@/stores/TypeAchatStore";
import DropDownField from "@/components/molecules/DropDownField.vue";

const notificationStore = NotificationStores();
const typeAchatStore = TypeAchatStore();

typeAchatStore.loadTypeAchat();

const props = defineProps({
  closeModal: Function,
  isVisible: {
    type: Boolean,
    required: true,
  }
});

const newLibelle = ref("");
const newPrix = ref(0);
const newTypeAchat = ref(-1);

const typeAchatAvailable = computed(() => {
  return typeAchatStore.typeAchat.map((type) => {
    return {
      id: type.uuid,
      display: type.libelle
    }
  });
})

const createRepair = () => {
  if(newLibelle.value === "" || newPrix.value === 0 || newTypeAchat.value === -1) {
    notificationStore.addNotification(t("needFillAllFields"), 'error');
    return;
  }

  props.closeModal({libelle: newLibelle.value, prix: newPrix.value, uuidTypeAchat: newTypeAchat.value});

  newLibelle.value = "";
  newPrix.value = 0;
  newTypeAchat.value = -1;
}

</script>

<style scoped>

</style>